export const templateOfEmbeddedCode = `
    <div class="row content-block">
        <div class="col-12 column px-8 py-4">
            <div class="embedded-code-wrapper">
                <iframe width="100%" height="100%" src="" frameborder="0" tag="embedded-code" class="default-code"></iframe>
            </div>
        </div>
    </div>
`
